import React, { useRef } from 'react';
import { useEnteredView } from '@fiverr-private/hooks';
import { ContactButtonDisplayComponent } from '../ContactButtonDisplayComponent';
import { useMonitoring } from '../../../../../monitoring';
import { useFloatingChatTrigger } from '../../useFloatingChatTrigger';
import { AiBriefMenuItem } from './AiBriefMenuItem';
import styles from './index.module.scss';

export const ContactOptions = ({ onContactClick, options, buttonCopy, contactButtonProps, renderTrigger }) => {
    const { handleContactButtonImpression } = useMonitoring();
    const { isFloatingChatEnabled } = useFloatingChatTrigger();

    const observableRef = useRef(null);

    useEnteredView(observableRef, {
        threshold: 1,
        onEntered: () => handleContactButtonImpression('ai_brief_drawer'),
    });

    const customTrigger = renderTrigger ? renderTrigger() : null;

    return (
        <div ref={observableRef} style={{ width: 'inherit', height: 'inherit', display: 'flex' }}>
            <AiBriefMenuItem
                options={options}
                priorInteraction={options.priorInteraction}
                onContactClick={onContactClick}
                trigger={
                    customTrigger || (
                        <ContactButtonDisplayComponent
                            className={styles.fullWidth}
                            buttonCopy={buttonCopy}
                            withGradient={isFloatingChatEnabled}
                            {...contactButtonProps}
                        />
                    )
                }
            />
        </div>
    );
};
